export default __webpack_public_path__ + "static/breadcrumbs-parts-dark-1121e5209789bef1d79027d415d3e9707570c969918564fefad3bba620135a4f.png";